import { DrEntity } from "./dr-entity";

export enum ReefReviewJobStatusType {
    CANCELLED = 'Cancelled',
    CANCELLING = 'Cancelling',
    COMPLETED = 'Completed',
    COMPLETEDWITHERRORS = 'Completed_with_Errors',
    FAILED = 'Failed',
    PAUSED = 'Paused',
    PAUSING = 'Pausing',
    QUEUED = 'Queued',
    REGISTERED = 'Registered',
    NONE = 'None',
    RESUMING = 'Resuming',
    RUNNING = 'Running',
    SUCCEEDED = 'Succeeded',
    FINISHED = 'Finished'

}

export class ReefReviewJobStatus extends DrEntity {
    reviewSystemUploadId: number;
    uploadState: string;
    description: string;
    reviewProjectId: string;
    count: number;
    errorCount: number;
    email: string;
    startTime: string;
    endTime: string;
    duration: string;
    uploadJobId: string;
    retryNotes: string;

    iconClass: string;
    iconTitle: string;
    tooltip: string;

    constructor(value?: Partial<ReefReviewJobStatus>) {
        super(value);
        if (value) {
            Object.assign(this, value);

            this.iconClass = this.getIconClassFromReefReviewJobStatus(this.uploadState?.toLocaleLowerCase());
            this.uploadState = this.getJobStatusDisplayValue(this.uploadState);
        }
    }

    getIconClassFromReefReviewJobStatus(jobStatus: string): string {
        const iconClasses = {
            'fa-close color-grey-10': jobStatus === ReefReviewJobStatusType.CANCELLED.toLowerCase(),
            'fa-close pausing-cancellation': jobStatus === ReefReviewJobStatusType.CANCELLING.toLowerCase(),
            'fa-check': jobStatus === ReefReviewJobStatusType.COMPLETED.toLowerCase() 
                || jobStatus === ReefReviewJobStatusType.FINISHED.toLowerCase()
                || jobStatus === ReefReviewJobStatusType.SUCCEEDED.toLowerCase(),
            'fa-exclamation-triangle': jobStatus === ReefReviewJobStatusType.COMPLETEDWITHERRORS.toLowerCase(),
            'failure-info-class fa-exclamation-circle': jobStatus === ReefReviewJobStatusType.FAILED.toLowerCase(),
            'fa-pause': jobStatus === ReefReviewJobStatusType.PAUSED.toLowerCase(),
            'fa-pause pausing-cancellation': jobStatus === ReefReviewJobStatusType.PAUSING.toLowerCase(),
            'fa-clock-o': jobStatus === ReefReviewJobStatusType.QUEUED.toLowerCase(),
            'fa-play': jobStatus === ReefReviewJobStatusType.RUNNING.toLowerCase() || jobStatus === ReefReviewJobStatusType.RESUMING.toLowerCase(),
            'none': jobStatus === ReefReviewJobStatusType.REGISTERED.toLowerCase()
                || jobStatus === ReefReviewJobStatusType.NONE.toLowerCase()
        };

        const props = Object.getOwnPropertyNames(iconClasses).filter(p => iconClasses[p]);
        if (props.length > 0) {
            return props[props.length - 1];
        }

        return null;
    }

    getJobStatusDisplayValue(jobStatus: string): string {
        let displayValue = '';

        switch (jobStatus) {
            case 'CANCELLED': displayValue = 'Cancelled'; break;
            case 'CANCELLING': displayValue = 'Cancelling'; break;
            case 'COMPLETED': displayValue = 'Completed'; break;
            case 'COMPLETED_WITH_ERRORS': displayValue = 'Completed with Errors'; break;
            case 'FAILED': displayValue = 'Failed'; break;
            case 'PAUSED': displayValue = 'Paused'; break;
            case 'PAUSING': displayValue = 'Pausing'; break;
            case 'QUEUED': displayValue = 'Queued'; break;
            case 'REGISTERED': displayValue = 'Registered'; break;
            case 'NONE': displayValue = 'None'; break;
            case 'RESUMING': displayValue = 'Resuming'; break;
            case 'RUNNING': displayValue = 'Running'; break;
            case 'SUCCEEDED': displayValue = 'Succeeded'; break;
            case 'FINISHED': displayValue = 'Finished'; break;
        }

        return displayValue
    }
}
